export function formatPlayActivityAt(playedAt) {
  if (!playedAt) return null;
  const d = new Date(playedAt);
  if (Number.isNaN(d.getTime())) return null;
  const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const y = new Date(today.getTime() - 86400000);
  const yStr = `${y.getFullYear()}-${String(y.getMonth() + 1).padStart(2, "0")}-${String(y.getDate()).padStart(2, "0")}`;
  const date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  if (date === todayStr) return `Today ${time}`;
  if (date === yStr) return `Yesterday ${time}`;
  return `${d.getMonth() + 1}/${d.getDate()} ${time}`;
}

export function formatPlayDateTime(date, time) {
  if (!date && !time) return null;
  const today = new Date().toISOString().split("T")[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];
  if (date === today) return `Today, ${time || ""}`.replace(/,\s*$/, "");
  if (date === yesterday) return `Yesterday, ${time || ""}`.replace(/,\s*$/, "");
  if (!date) return time || null;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return [date, time].filter(Boolean).join(" ");
  return `${d.getMonth() + 1}/${d.getDate()}${time ? `, ${time}` : ""}`;
}

export function getPlayerResultDisplay(recent, formatCoin) {
  if (!recent) return { text: "—", tone: "neutral" };
  const status = String(recent.status || "").toLowerCase();
  const stake = Number(recent.stake || 0);
  const actualWin = Number(recent.actualWin || 0);
  if (status === "won") {
    return { text: `+${formatCoin(actualWin)}`, tone: "win" };
  }
  if (status === "refunded" || status === "cancelled" || status === "expired") {
    return { text: `+${formatCoin(stake)}`, tone: "refund" };
  }
  return { text: `-${formatCoin(stake)}`, tone: "loss" };
}

export function formatInvestorProfitDisplay(profit, formatCoin) {
  const value = Number(profit || 0);
  if (value === 0) return "—";
  return `${value >= 0 ? "+" : ""}${formatCoin(value)}`;
}

export function activityStatusTone(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "won") return "won";
  if (normalized === "pending") return "pending";
  if (normalized === "refunded" || normalized === "cancelled" || normalized === "expired") {
    return "refunded";
  }
  return "lost";
}

export function activityStatusLabel(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "cancelled") return "CANCELLED";
  if (normalized === "expired") return "EXPIRED";
  if (!normalized) return "—";
  return normalized.toUpperCase();
}

export function hasRoundContext(game, type) {
  if (!game) return false;
  if (type === "dice" || type === "numbers") {
    return game.playerPick != null || game.playerFace != null || game.outcome != null;
  }
  return game.playerSide != null || game.outcome != null;
}

export function getInvestorSharePercent(recent) {
  if (!recent) return "0.0";
  if (recent.sharePercent != null) {
    const pct = Number(recent.sharePercent);
    return Number.isFinite(pct) ? pct.toFixed(1) : "0.0";
  }
  const inv = Number(recent.investment || 0);
  const poolSize = Number(recent.poolSize || 0);
  if (!Number.isFinite(inv) || !Number.isFinite(poolSize) || poolSize <= 0) return "0.0";
  const pct = (inv / poolSize) * 100;
  return Number.isFinite(pct) ? pct.toFixed(1) : "0.0";
}

export function investorOutcomeLabel(profit, status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "pending") return "Reserved";
  if (normalized === "cancelled" || normalized === "expired" || normalized === "refunded") return "Released";
  const value = Number(profit || 0);
  if (value > 0) return "Player lost";
  if (value < 0) return "Player won";
  return "Settled";
}
